import type { SVGProps } from "react";

export function Spark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      fill="currentColor"
      {...props}
    >
      <rect
        x="673.44"
        y="737.29"
        width="290.45"
        height="503.53"
        transform="translate(-465.09 1009.62) rotate(-51.3)"
      />
      <polygon points="763.89 1125.61 535.26 946.46 1208.79 86.91 1208.71 101.44 763.89 1125.61" />
      <polygon points="435.22 1888.68 424.95 1891.9 880.12 849.99 1108.74 1029.14 435.22 1888.68" />
      <rect
        x="1208.86"
        y="783.71"
        width="190.78"
        height="330.73"
        transform="translate(-308.76 945.83) rotate(-35.93)"
      />
      <polygon points="1245.78 1026.02 1132.18 872.75 1708.43 445.67 1705.85 454.85 1245.78 1026.02" />
      <polygon points="904.73 1452.06 897.67 1452.31 1367.38 871.71 1480.98 1024.98 904.73 1452.06" />
    </svg>
  );
}
